import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingEventName, UploadPhotoChooseLibraryOptionCanceledTrackingEvent } from "./tracking";

interface TrackUploadPhotoChooseLibraryOptionCanceledFunction {
  (): void;
}

interface UseTrackUploadPhotoChooseLibraryOptionCanceledFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string;
  readonly tradename: Tradename;
}

interface UseTrackUploadPhotoChooseLibraryOptionCanceledFunction {
  (
    agrs: UseTrackUploadPhotoChooseLibraryOptionCanceledFunctionArgs,
  ): TrackUploadPhotoChooseLibraryOptionCanceledFunction;
}

const useTrackUploadPhotoChooseLibraryOptionCanceled: UseTrackUploadPhotoChooseLibraryOptionCanceledFunction = ({
  country,
  segment,
  customerId,
  tradename,
}) => {
  const emitUserEvent = useEmitUserEvent<UploadPhotoChooseLibraryOptionCanceledTrackingEvent>();

  const trackUploadPhotoChooseLibraryOptionCanceled: TrackUploadPhotoChooseLibraryOptionCanceledFunction =
    useCallback(() => {
      emitUserEvent({
        event: TrackingEventName.UPLOAD_PHOTO_CHOOSE_LIBRARY_OPTION_CANCELED,
        eventCategory: TrackingEventCategory.NAVIGATION,
        section: `${PROJECT}_photos`,
        store: country,
        segment,
        userId: customerId,
        tradename,
      });
    }, [country, customerId, tradename, emitUserEvent, segment]);

  return trackUploadPhotoChooseLibraryOptionCanceled;
};

export { useTrackUploadPhotoChooseLibraryOptionCanceled };
